import { useEffect, useState } from 'react';

type Theme = 'light' | 'dark';

// const THEME_STORAGE_KEY = 'theme';

// const getStorageTheme = (): Theme | undefined => {
//   // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
//   if (globalThis.window === undefined) return undefined;
//   try {
//     const stored = localStorage.getItem(THEME_STORAGE_KEY);
//     if (stored === 'light' || stored === 'dark') {
//       return stored;
//     }
//   } catch {
//     // Ignore storage errors
//   }
//   return undefined;
// };

// const getSystemTheme = (): Theme => {
//   // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
//   if (globalThis.window === undefined) return 'light';
//   return globalThis.window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
// };

// const setStorageTheme = (theme: Theme): void => {
//   // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
//   if (globalThis.window === undefined) return;
//   try {
//     localStorage.setItem(THEME_STORAGE_KEY, theme);
//   } catch {
//     // Ignore storage errors
//   }
// };

const applyTheme = (theme: Theme): void => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (globalThis.window === undefined) return;
  const root = document.documentElement;
  if (theme === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
};

export function useTheme() {
  // FORCED LIGHT THEME - Uncomment below to enable theme switching
  const [theme] = useState<Theme>('light');
  // const [theme, setThemeState] = useState<Theme>(() => {
  //   return getStorageTheme() ?? getSystemTheme();
  // });

  useEffect(() => {
    // FORCED LIGHT THEME
    applyTheme('light');

    // Uncomment below to enable theme switching
    // applyTheme(theme);
    // setStorageTheme(theme);
  }, []);
  // }, [theme]);

  // const setTheme = (newTheme: Theme) => {
  //   setThemeState(newTheme);
  // };

  // const toggleTheme = () => {
  //   setThemeState((prev) => (prev === 'dark' ? 'light' : 'dark'));
  // };

  return {
    theme,
    // setTheme,
    // toggleTheme,
  };
}
